module.exports = __webpack_public_path__ + "img/login-l.6f1bc010.jpg";